import type { StrictPropertyList } from '@yp/common/schema/descriptor.ts';
import { Scalar, Seconds, Time } from '@yp/common/units.ts';

export type ServerProblem = {
  delay?: Scalar<Time>;
  error?: string;
  requireLogin?: boolean;
};

export const ServerProblemDesc: StrictPropertyList<ServerProblem> = [
  { k: 'delay', t: 'scalar', u: Seconds, label: 'Delay (seconds)' },
  { k: 'error', t: 'string', label: 'Error Message' },
  { k: 'requireLogin', t: 'bool', label: 'Require Login?' },
];
